import React from 'react';
import PT from 'prop-types';
import { Box, Button, colors } from '@procore/core-react';
import { Clear } from '@procore/core-icons';
import styled from 'styled-components';

const HeaderContainer = styled(Box)`
  background-color: ${colors.white};
  border-bottom: 1px solid ${colors.gray85};
`;

export const MobileOverlayHeader = ({ onClose, children }) => (
  <HeaderContainer
    display="flex"
    justifyContent="space-between"
    alignItems="center"
    padding="lg xl"
  >
    <Box>{children}</Box>

    <Button
      variant="tertiary"
      icon={<Clear />}
      onClick={onClose}
      data-testid="close-overlay"
    />
  </HeaderContainer>
);

MobileOverlayHeader.propTypes = {
  onClose: PT.func.isRequired,
  children: PT.node.isRequired,
};
